import { flow } from 'mobx-state-tree';

// Types
import { Patient } from '@common/models/patients/types';

import http from '@clientCommon/app/bootstrap/http';

import { API_BASE } from '@clientCommon/app/constants';
import { MODEL_ROUTE } from '../../constants';

type Filter = {
  firstName?: string;
  lastName?: string;
  externalPharmacyId?: string;
};

type Query = {
  offset?: number;
  limit?: number;
};

export default flow(function* (filter: Filter = {}, query?: Query) {
  const response: { data: Patient[] } = yield http.get({
    url: `${API_BASE}${MODEL_ROUTE}`,
    query: { ...(query || {}), filter },
  });

  return response.data;
});
